import { useContext, FC, useEffect } from "react";
import { ShepherdTourContext } from "react-shepherd";
import { useRouteMatch } from "react-router-dom";
import * as _ from "lodash";

import { useOnboarding } from "../../providers";

/**
 *
 * Tour component
 */
export const Tour: FC = () => {
  const tour = useContext(ShepherdTourContext);
  const { path } = useRouteMatch();
  const { onboardedModules, setOnboardedModules } = useOnboarding();
  /**
   * @todo for now the product tour is enabled only for overview
   * replace "/app/overview" with path when other modules are replaced
   */
  const onboarded = _.get(onboardedModules, "/app/overview", null);

  /**
   * Start the module path tour
   */
  useEffect(
    () => {
      if (tour && !onboarded) {
        /**
         * If the value is NULL (never seen the onboarding)
         * then we don't start it. This way we can only show on-demand, when
         * the value is explicitly set as false.
         */
        if (!_.isNull(onboarded)) {
          tour.start();
        }

        setOnboardedModules({ ...onboardedModules, [path]: true });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onboarded]
  );

  return null;
};
